import FindingsList from './FindingsList';
import { listAllFindings } from '../../../services/securityhubApi';
import { accessAnalyzerEngine } from './engines/accessanalyzer';

// AWS IAM Access Analyzer findings.
//
// The source is the UNIFIED inbox scoped to this engine, not accessAnalyzerApi's
// listAccessAnalyzerFindings: /findings/all returns the NormalizedFinding shape
// the shared table renders (findingId / workflowStatus / lastObservedAt) and tags
// each row engine='accessanalyzer', which is what makes a row click open the
// Access Analyzer detail body. The engine-native endpoint returns this
// capability's own DTO (awsFindingId / status / lastSeenAt), whose field names the
// table does not read.
//
// Consequence worth knowing: the status filter therefore speaks the NORMALIZED
// vocabulary (NEW/SUPPRESSED), which accessAnalyzerStatusFromWorkflow maps back to
// AWS's ACTIVE/ARCHIVED server-side. Sending ACTIVE/ARCHIVED from here would match
// no token in that mapper, and an unrecognised status list applies NO filter at
// all - so the chip would silently return every row while looking like it worked.
const accessAnalyzerSource = (filters) => listAllFindings({ ...filters, engine: ['accessanalyzer'] });

// Accent and icon come from the engine descriptor rather than local constants so
// this page cannot drift from the sidebar entry and the Overview tile.
const AccessAnalyzerIcon = accessAnalyzerEngine.Icon;

export default function AccessAnalyzerFindings() {
  return (
    <FindingsList
      source={accessAnalyzerSource}
      engineKind="accessanalyzer"
      subtitle="Access Analyzer findings"
      color={accessAnalyzerEngine.color}
      icon={<AccessAnalyzerIcon sx={{ fontSize: 24 }} />}
    />
  );
}
